import { render } from "./ClaimHistoricalInformationModal.vue?vue&type=template&id=41ec4817"
import script from "./ClaimHistoricalInformationModal.vue?vue&type=script&lang=js"
export * from "./ClaimHistoricalInformationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__